import { render, staticRenderFns } from "./NlpWhoIsForIcon2.vue?vue&type=template&id=43225635"
import script from "./NlpWhoIsForIcon2.vue?vue&type=script&lang=js"
export * from "./NlpWhoIsForIcon2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports